module.exports = __webpack_public_path__ + "img/menu.c625f488.png";